import * as React from 'react';
import Spinner from './Spinner';

export default ({visible = true}: LoadingSpinnerProps) => (
   <div style={{visibility: visible ? 'visible' : 'hidden'}} className="loading-spinner">
      {Spinner}
   </div>
);

interface LoadingSpinnerProps {
   visible?: boolean;
}
